import React from "react";
import styled from "styled-components";

const LegendItemWrapper = styled.div`
  display: inline-flex;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0px 0 0px;
  gap: 5px;
  align-items: center;
  cursor: pointer;
  width: 15ch;

  .square {
    width: 12px;
    min-width: 12px;
    height: 12px;
    border: 2px solid;
    border-radius: 6px;
  }

  label {
    user-select: none;
    margin-bottom: 0;
    font-size: 13px;
    font-weight: normal;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;


export const LegendItem = ({ label, isSelected, onSelection, color, field }) => {
    const handleClick = () => {
      onSelection(field);
    };
    return (
      <LegendItemWrapper onClick={handleClick}>
        <div
          className="square"
          style={{
            backgroundColor: isSelected ? color : "transparent",
            borderColor: color,
          }}
        ></div>
        <label title={label}>{label}</label>
      </LegendItemWrapper>
    );
  };